module.exports = __webpack_public_path__ + "static/media/s_v10_9.d4bda0e7.mp3";